export * from './delete-projekt.service';
export * from './delete-projekt.service.module';